import { Routing } from '@/constants';
export const isHomePage = (pathname) => pathname === Routing.MERCHANDISING_PATH || pathname === '/';
